import React from "react";
import { Form, Checkbox } from "antd";
const Typerdv = props => {
	return (
		<React.Fragment>
			<Form.Item {...props.formItemLayout} label="Type rdv">
				{props.getFieldDecorator("rdv", {
					initialValue: props.defaultValue,
					valuePropName: "checked",
				})(<Checkbox disabled={props.disabled}>rdv</Checkbox>)}
			</Form.Item>
		</React.Fragment>
	);
};

export default Typerdv;



// WEBPACK FOOTER //
// src/components/planning/FormItems/Typerdv.js